// ═══ 현장계약서(SALES CONTRACT) HTML 생성 + 인쇄 + 서버 저장 ═══
// CarList.js의 printContract 함수에서 추출. ctx에 모든 폼 상태를 받아 새 창에 인쇄용 HTML을 작성하고
// 동시에 /sales-contract/save 로 PDF 서버 저장 + saveContractData/closeContract 콜백을 호출.
import { API, authFetch } from './api';
import { wonFromMan } from './format';
import { getYearFromVin } from './vinDecoder';
import { getEngCarName } from './carNames';

function printContract(ctx) {
  var contractCars = ctx.contractCars;
  var contractPrices = ctx.contractPrices;
  var contractDeposit = ctx.contractDeposit;
  var contractBuyerName = ctx.contractBuyerName;
  var contractBuyerPhone = ctx.contractBuyerPhone;
  var contractBankInfo = ctx.contractBankInfo;
  var contractDocPhone = ctx.contractDocPhone;
  var contractCompany = ctx.contractCompany;
  var companyInfo = ctx.companyInfo;
  var setModal = ctx.setModal;
  var closeModal = ctx.closeModal;
  var saveContractData = ctx.saveContractData;
  var closeContract = ctx.closeContract;

  if (contractCars.length === 0) return;
  var hasPrice = contractCars.some(function(c){return contractPrices[c.id]});
  if (!hasPrice) { setModal({type:'danger',title:'실패',message:'인보이스 금액을 1대 이상 입력해주세요',hideCancel:true,onConfirm:closeModal}); return; }
  localStorage.setItem('contract_bankInfo', contractBankInfo);
  localStorage.setItem('contract_docPhone', contractDocPhone);
  var now = new Date();
  var dateStr = now.getFullYear()+'.'+(now.getMonth()+1<10?'0':'')+(now.getMonth()+1)+'.'+(now.getDate()<10?'0':'')+now.getDate();
  var ci = contractCompany || companyInfo || {};
  var cName=ci.companyName||'', cAddr=ci.addr||'', cTel=ci.tel||'', cFax=ci.fax||'', cEmail=ci.email||'', cCeo=ci.ceo||'';
  var carRows = '';
  var totalPrice = 0;
  for (var i = 0; i < contractCars.length; i++) {
    var c = contractCars[i];
    var p = Number(contractPrices[c.id]) || 0;
    totalPrice += p;
    var vinYr = getYearFromVin(c.vin, c.regDate ? parseInt(c.regDate.slice(0,4)) : null);
    var yr = vinYr ? String(vinYr) : (c.regDate ? (c.regDate||'').slice(0,4) : '');
    var engName = getEngCarName(c.carType || '');
    carRows += '<tr><td style="text-align:center;font-size:14px">'+(i+1)+'</td><td style="font-weight:700;font-size:14px">'+engName+'</td><td style="text-align:center;font-size:14px">'+yr+'</td><td style="font-size:14px">'+(c.vin||'')+'</td><td style="text-align:right;font-weight:700;font-size:14px">'+(p?wonFromMan(p).toLocaleString():'')+'</td></tr>';
  }
  var depositMan = Number(contractDeposit) || 0;
  var balanceMan = totalPrice - depositMan;
  var depositWon = wonFromMan(depositMan);
  var balanceWon = wonFromMan(balanceMan);
  var depositStr = depositMan>0 ? (depositWon).toLocaleString() : '';
  var balanceStr = balanceMan<=0 ? 'PAID' : (balanceWon).toLocaleString();

  var html = '<!DOCTYPE html><html><head><meta charset="utf-8">'
    +'<style>'
    +'@page{size:A4;margin:12mm 15mm}'
    +'@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}'
    +'body{font-family:"Times New Roman",Georgia,serif;font-size:14px;color:#000;margin:0;padding:15px 28px;line-height:1.5}'
    +'table{border-collapse:collapse;width:100%}'
    +'td,th{border:1px solid #000;padding:5px 8px;font-size:14px;vertical-align:middle}'
    +'</style></head><body>'
    +'<div style="text-align:center;margin-bottom:4px">'
    +'<div style="font-size:26px;font-weight:700;letter-spacing:2px">&#9670; '+cName+'</div>'
    +'<div style="font-size:11px;margin:3px 0">'+cAddr+'</div>'
    +'<div style="font-size:11px">'+(cFax?'Fax:'+cFax+'&nbsp;&nbsp;&nbsp;':'')+(cTel?'M.P.:'+cTel:'')+'</div>'
    +(cEmail?'<div style="font-size:11px">e-mail:'+cEmail+'</div>':'')
    +'</div>'
    +(contractDocPhone?'<div style="text-align:center;font-weight:700;font-size:13px;margin:4px 0">면장(DOCUMENTS) : '+contractDocPhone+'</div>':'')
    +'<hr style="border:none;border-top:1.5px solid #000;margin:6px 0">'
    +'<div style="display:flex;justify-content:center;align-items:center;position:relative;margin:10px 0">'
    +'<div style="font-size:18px;font-weight:700;text-decoration:underline;letter-spacing:4px">SALES CONTRACT</div>'
    +'<div style="position:absolute;right:0;font-size:13px">'+dateStr+'</div>'
    +'</div>'
    +'<p style="font-size:12px;margin:6px 0 10px">We as Seller confirm having sold you as Buyer the following goods on the terms and conditions as stated below and on the back hereof.</p>'
    +'<table>'
    +'<tr style="background:#f0f0f0"><th style="width:40px;font-size:14px">NO.</th><th style="font-size:14px">CAR NAME</th><th style="width:60px;font-size:14px">YEAR</th><th style="font-size:14px">CHASSIS NO.</th><th style="width:110px;text-align:right;font-size:14px">UNIT PRICE</th></tr>'
    +carRows
    +'<tr><td colspan="2" style="font-weight:700;font-size:14px">BANK ACCOUNT</td><td colspan="3" style="font-size:14px">'+(contractBankInfo||'')+'</td></tr>'
    +'<tr><td colspan="2" style="border:none"></td><td style="font-weight:700;font-size:16px">TOTAL</td><td colspan="2" style="text-align:right;font-weight:700;font-size:16px">'+wonFromMan(totalPrice).toLocaleString()+'</td></tr>'
    +'<tr><td colspan="2" style="border:none"></td><td style="font-weight:700;font-size:16px">DEPOSIT</td><td colspan="2" style="text-align:right;font-weight:700;font-size:16px">'+depositStr+'</td></tr>'
    +'<tr><td colspan="2" style="border:none"></td><td style="font-weight:700;font-size:16px">BALANCE</td><td colspan="2" style="text-align:right;font-weight:700;font-size:16px">'+(depositMan>0?balanceStr:'')+'</td></tr>'
    +'</table>'
    +'<div style="margin:16px 0 8px;font-size:14px"><b>Origin &nbsp; : &nbsp; Republic of Korea</b></div>'
    +'<div style="font-size:13px;line-height:1.9">'
    +'<p style="margin:2px 0"><b>1. You must pay the balance within 7 days of paying the DEPOSIT.</b></p>'
    +'<p style="margin:2px 0"><b>2. Otherwise, the contract is terminated and DEPOSIT is not returned.</b></p>'
    +'<p style="margin:2px 0"><b>3. You must bring your car within 3 days of completing your payment.</b></p>'
    +'<p style="margin:2px 0"><b>4. If you do not comply with paragraph 4. You will have to pay $100 a day for storage</b></p>'
    +'</div>'
    +'<div style="margin:12px 0;font-size:13px"><b>Payment :</b> &nbsp; By irrevocable documentary credit at sight to be issued in favor of<br>'
    +'<span style="margin-left:80px">'+cName+'</span></div>'
    +'<p style="font-size:14px;font-weight:700;margin:14px 0">Please sign and return the duplicate</p>'
    +'<div style="display:flex;justify-content:space-between;margin:20px 0 10px">'
    +'<div style="width:45%">'
    +'<div style="font-size:14px;margin-bottom:8px"><i>Buyer:</i></div>'
    +'<div style="border-bottom:1px solid #000;height:30px;font-size:16px;font-weight:700;display:flex;align-items:flex-end;padding-bottom:4px">'+(contractBuyerName||'')+'</div>'
    +'<div style="margin-top:12px"><span style="font-size:13px;color:#555">Phone: </span><b style="font-size:14px">'+(contractBuyerPhone||'')+'</b></div>'
    +'</div>'
    +'<div style="width:45%;text-align:right">'
    +'<div style="font-size:14px;margin-bottom:8px"><b>Seller: &nbsp; '+cName+'</b></div>'
    +'<div style="border-bottom:1px solid #000;height:30px;display:flex;align-items:flex-end;justify-content:flex-end;padding-bottom:4px"></div>'
    +'<div style="font-size:14px;margin-top:4px;font-weight:700">'+(cCeo?cCeo+' / PRESIDENT':'')+'</div>'
    +'</div></div>'
    +'</div>'
    +'<script>window.onload=function(){window.print()}<\/script>'
    +'</body></html>';

  var w = window.open('', '_blank');
  if (w) { w.document.write(html); w.document.close(); }
  // 현장계약서 PDF 저장 + 차량 DB 업데이트는 saveContractData 가 Promise.all 로 일괄 처리.
  // (과거엔 여기서도 /sales-contract/save 를 호출했지만 saveContractData 로 일원화 —
  //  저장 버튼과 출력 버튼이 동일 저장 경로 공유. race fix 로 모든 PUT+PDF 완료 후 ld)
  saveContractData(true);
  closeContract();
}

export { printContract };
